import {
  json as baseJson,
  info as baseInfo,
} from '../../Base/Mystery-Gift_oneColumn'
import themeBase from './_themeBase'
import INDEX from './_index'

const info = JSON.parse(JSON.stringify(baseInfo))
const json = JSON.parse(JSON.stringify(baseJson))
const templateID = info.templateID + INDEX

info.templateID = templateID
// info.name = 'Black Friday:' + info.name

json.templateID = templateID

// Apply theme-specific styling overrides
json.styling = {
  ...json.styling,
  backgroundColor: '#FEFEFE',
  backgroundImage: '',
}

json.theme = themeBase.theme

// Modify content items as needed
// json.steps[0].contentItems = json.steps[0].contentItems.map((item) => {
//   if (item.type === 'headline') {
//     item.content.text = 'Black Friday Specials Await!'
//     item.styling.fontSize = '40px'
//   }
//   return item
// })

export { json, info };